module.exports = __webpack_public_path__ + "img/orange_unlock.472a8775.png";